import {Injectable} from "@angular/core";


const APP_PREFIX = 'CF-';
export const PAGE_SIZE = 'PAGE_SIZE';
export const TABLE_LAYOUT = 'TABLE_LAYOUT';
export const PINNED_ITEMS = 'PINNED_ITEMS';
export const KEY_THEME = 'KEY_THEME';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

  /**
   * Sets item in local storage
   *
   * @param {string} key
   * @param {*} value
   */
  public setItem(key: string, value: any) {
    try {
      localStorage.setItem(`${APP_PREFIX}${key}`, JSON.stringify(value));
    } catch (e) {
      localStorage.setItem(`${APP_PREFIX}${key}`, value);
    }
  }

  /**
   * Gets item from local storage by key
   *
   * @param {string} key
   * @return {*}  {*}
   */
  public getItem(key: string): any {
    const value = localStorage.getItem(`${APP_PREFIX}${key}`);
    try {
      return JSON.parse(value as any);
    } catch (e) {
      return value;
    }
  }

  /**
   * Removes item from local storage by key
   *
   * @param {string} key
   */
  public deleteItem(key: string) {
    localStorage.removeItem(`${APP_PREFIX}${key}`);
  }

}
